import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Localization } from 'constant/config';
import { Button, Form, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { userLogout } from 'redux/auth/actions';
import { clearActionStatus, createRecord } from 'redux/crud/action';
import { State } from 'redux/types';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const link = Localization.eulaTextUrl;

const Eula = ({ version, setShowEula }: any) => {
  const { t } = useTranslation();
  const { auth } = useSelector((state: State) => state);
  const [content, setContent] = useState('');
  const [agree, setAgree] = useState(false);
  const dispatch = useDispatch();
  const getEulaFile = () => {
    fetch(link)
      .then((r) => r.text())
      .then((text) => {
        setContent(text);
      });
  };
  const history = useHistory();
  useEffect(() => {
    getEulaFile();
  }, []);

  const render = () => {
    return content.split('\n').map((item, key) => (
      <span key={key}>
        {item}
        <br />
      </span>
    ));
  };

  const handleSubmit = () => {
    if (agree) {
      dispatch(
        createRecord('userEula', 'user-legal', {
          version,
          is_accepted: true,
          type: 'eula',
        }),
      );
    } else {
      dispatch(userLogout());
      dispatch(clearActionStatus('userEula'));
    }
    setShowEula(false);
  };

  return (
    <>
      <ModalHeader className="justify-content-center">
        <div
          style={{
            fontWeight: 500,
            fontSize: '20px',
            color: '#000',
          }}
        >
          {t('End User License Agreement')}
        </div>
      </ModalHeader>
      <ModalBody className="p-0">
        <div
          style={{
            maxHeight: '500px',
            overflowY: 'scroll',
            padding: '30px',
          }}
        >
          <div 
            style={{
              fontWeight: '700',
              paddingBottom: 20,
            }}
            className="text-danger"
          >
            {t('Please scroll down to accept the agreement')}
          </div>
          {render()}
          <div
            style={{
              padding: '10px 0px 20px',
            }}
          >
            <Form>
              <FormGroup check className="mt-3">
                <Input
                  type="checkbox"
                  name="check"
                  id="eulaCheck"
                  defaultChecked={false}
                  onChange={() => setAgree(!agree)}
                />
                <Label for="eulaCheck" check>
                  {t('I agree to the above Terms & Conditions')}
                </Label>
              </FormGroup>
            </Form>
            {/* {!agree && <div className="text-danger">{t('If you reject the Terms & Conditions, you will be logged out.')}</div>} */}
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="text-center justify-content-center">
        <LegalButton onClick={() => handleSubmit()} style={{ borderRadius: 8, color: '#ffffff' }} disabled={!agree}>
          {t('Next')}
        </LegalButton>
      </ModalFooter>
    </>
  );
};

export default Eula;

export const LegalButton = styled(Button)`
  font-weight: 500;
  font-size: 20px;
  background: #6956BA;
  padding: 10px 24px;
`;
